module.exports = __webpack_public_path__ + "img/kc.78e46ea0.png";